module.exports = __webpack_public_path__ + "static/media/more-btn.e980a805.svg";